import styled from 'styled-components'

const SidebarNavigationSubItems = styled.ul`
background: #222;
max-height: 0;
overflow: hidden;
transition: max-height 250ms ease-in-out;
`

export default SidebarNavigationSubItems